import { ReactComponent as Elevator } from '../assets/images/assetFeatures/Elevator.svg';
import { ReactComponent as Storage } from '../assets/images/assetFeatures/Storage.svg';
import { ReactComponent as Pool } from '../assets/images/assetFeatures/Pool.svg';
import { ReactComponent as Bathroom } from '../assets/images/assetDetails/Bathroom.svg';
import { ReactComponent as Bedroom } from '../assets/images/assetDetails/Bedroom.svg';
import { ReactComponent as Building } from '../assets/images/assetDetails/Building.svg';
import { ReactComponent as Area } from '../assets/images/assetDetails/Builtarea.svg';
import { ReactComponent as Condition } from '../assets/images/assetDetails/assetCondition.svg';
import { ReactComponent as Exterior } from '../assets/images/assetFeatures/Exterior.svg';
import { ReactComponent as Parking } from '../assets/images/assetFeatures/Parking.svg';
import { ReactComponent as AirConditioner } from '../assets/images/assetFeatures/AirConditioner.svg';
import { ReactComponent as Terrace } from '../assets/images/assetFeatures/Terrace.svg';
import { ReactComponent as AutomaticDoor } from '../assets/images/assetFeatures/garage/AutomaticDoor.svg';
import { ReactComponent as People } from '../assets/images/assetFeatures/building/People.svg';
import { ReactComponent as Security } from '../assets/images/assetFeatures/building/Security.svg';
import { ReactComponent as Pavement } from '../assets/images/assetFeatures/land/Pavement.svg';
import { ReactComponent as Water } from '../assets/images/assetFeatures/land/Water.svg';
import { ReactComponent as Sewerage } from '../assets/images/assetFeatures/land/Sewerage.svg';
import { ReactComponent as StreetLighting } from '../assets/images/assetFeatures/land/StreetLighting.svg';
import { ReactComponent as Electricity } from '../assets/images/assetFeatures/land/Electricity.svg';
import { ReactComponent as NaturalGas } from '../assets/images/assetFeatures/land/NaturalGas.svg';

export const ListingTypeDictionary = {
  1: 'residential',
  2: 'Oficina',
  5: 'Local',
  6: 'Nave industrial',
  7: 'Garaje',
  8: 'Terreno',
  11: 'Trastero',
  12: 'Edificio',
};

export const SubtypologyDictionary = {
  0: 'Unknown',
  1: 'Penthouse',
  2: 'Duplex',
  3: 'Detached House',
  4: 'Apartment',
  5: 'Semi-detached house',
  6: 'Terraced house',
  // TODO: fill the rest
};

export const OperationDictionary = {
  0: 'Alquiler',
  1: 'Compra venta',
};

export const CategoryLabels = {
  1: '<70m²',
  2: '70-100m²',
  3: '100-140m²',
  4: '140-180m²',
  5: '180-250m²',
  6: '>250m²',
};

export const CategoryTags = {
  1: 'XS',
  2: 'S',
  3: 'M',
  4: 'L',
  5: 'XL',
  6: 'XXL',
};

export const PublishingStatusDictionary = {
  0: 'Despublicado',
  1: 'Publicado',
  2: 'Vendido',
  3: 'Tasación',
  4: 'Comp. tasación',
  5: 'Valoración',
  99: 'Otros'
};

export const getStudyCategoryDictionary = (intl) => ({
  college: intl.formatMessage({ id: 'zonePopulation.college' }),
  secondary: intl.formatMessage({ id: 'zonePopulation.secondary' }),
  primary: intl.formatMessage({ id: 'zonePopulation.primary' }),
});

export const PropertyTypeDictionary = {
  0: 'Unknown',
  1: 'Penthouse',
  2: 'Duplex',
  3: 'Detached House',
  4: 'Piso',
  5: 'Semi-detached house',
  6: 'Terraced house',
  7: 'Study',
  8: 'Rustic villa',
  9: 'Room',
  21: 'Mixed use',
  23: 'In Shopping Mall',
  24: 'Mezzanine',
  25: 'Underground',
  26: 'Other',
  27: 'Offices only',
  33: 'Parking slot for car',
  34: 'Parking slot for car and moto',
  35: 'Parking slot two cars or more',
  36: 'Parking slot big car',
  37: 'Parking slot small car',
  38: 'Urban land',
  39: 'At street level',
  40: 'Storage room',
  41: 'Hotel',
  42: 'Developable land',
  43: 'Store',
  44: 'Building',
  45: 'Office unit',
  46: 'Warehouse',
  47: 'Factory',
  48: 'Logistic',
  55: 'Farm',
  56: 'Mixed industrial ship',
  57: 'Condominium',
  58: 'Special Asset',
  59: 'Garage',
};

export const glossaryTexts = {
  main: [
    {
      key: 'rentPrice',
      title: 'Precio de alquiler',
      description:
        'Precio estimado de alquiler sin suministros teniendo en cuenta la información provista por el solicitante de la valoración, los datos disponibles de la zona y de los testigos recientes.',
    },
    {
      key: 'salePrice',
      title: 'Precio de venta',
      description:
        'Precio estimado de cierre de la compraventa teniendo en cuenta la información provista por el solicitante de la valoración, los datos disponibles de la zona y de los testigos recientes. Se diferencia según el estado de la vivienda: si está a estrenar, en buen estado o precisa de reforma parcial o total.',
    },
    {
      key: 'weeksToSell',
      title: 'Semanas para vender',
      description: 'Tiempo medio estimado de cierre de la venta del inmueble.',
    },
    {
      key: 'negotiationMargin',
      title: 'Margen de negociación',
      description:
        'Diferencia media para inmuebles similares entre el precio solicitado y el de cierre de la compraventa.',
    },
    {
      key: 'grossYield',
      title: 'Rentabilidad bruta',
      description:
        'Cociente entre los ingresos anuales estimados del alquiler asumiendo plena ocupación y el precio de venta.',
    },
    {
      key: 'priceEvolution',
      title: 'Evolución del último año',
      description:
        'Variación porcentual del precio de venta estimado en los últimos 12 meses para una vivienda, un barrio, una ciudad o un país.',
    },
  ],
  supply_and_demand: [
    {
      key: 'supply',
      title: 'Oferta',
      description:
        'Distribución porcentual del número de viviendas actualmente ofertadas en la zona atendiendo a la superficie construida del inmueble.',
    },
    {
      key: 'demand',
      title: 'Demanda',
      description:
        'Distribución porcentual del número de demandantes de vivienda en la zona atendiendo a la superficie construida del inmueble demandado.',
    },
    {
      key: 'supplyByPurpose',
      title: 'Oferta por finalidad',
      description:
        'Distribución porcentual del número de viviendas ofertadas actualmente en la zona según estén destinadas a la venta o al alquiler.',
    },
    {
      key: 'mostDemandedHousing',
      title: 'Vivienda más demanda',
      description: 'Tamaño de vivienda más demandada en la zona.',
    },
    {
      key: 'averageBuildingAge',
      title: 'Edad media de edificación',
      description:
        'Edad media de los inmuebles de la zona atendiendo al año de obtención de la célula de habitabilidad.',
    },
  ],
  who_lives_in_the_area: [
    {
      key: 'averageAge',
      title: 'Edad media',
      description: 'Edad media de los habitantes censados en la zona.',
    },
    {
      key: 'averageIncomePerHousehold',
      title: 'Renta media por hogar',
      description:
        'Renta media por hogar bruta (antes de impuestos y cotizaciones por cuenta del trabajador).',
    },
    {
      key: 'educationLevel',
      title: 'Nivel de estudios',
      description:
        'Porcentaje de la población censada en la zona con estudios universitarios o superiores.',
    },
    {
      key: 'households',
      title: 'Hogares',
      description:
        'Distribución porcentual de los hogares de la zona por número de personas censadas en ellos.',
    },
    {
      key: 'nationality',
      title: 'Nacionalidad',
      description:
        'Porcentaje de nacionalidad extranjera censada en la zona, así como nacionalidades de mayor peso.',
    },
  ],
  know_the_area: [
    {
      key: 'knowTheZone',
      title: 'Conoce la zona',
      description:
        'Calidad de la zona en cuanto a su accesibilidad a transporte público, así como número de entidades educativas, comercios y equipamiento deportivo y de ocio. Puntuación relativa comparada con la media nacional.',
    },
  ],
  recent_similar_witnesses: [
    {
      key: 'recentSimilarWitnesses',
      title: 'Testigos similares recientes',
      description:
        'Precio de cierre estimado en testigos recientes en la zona relativas a inmuebles de similares características en cuanto a su tipología y tamaño.',
    },
  ],
  valuation: [
    {
      key: 'valuation',
      title: 'Modelos de valoración',
      description:
        'Modelos de valoración utilizados para la valoración del inmueble.',
    },
    {
      key: 'ecoComparables',
      title: 'Modelo ECO comparables',
      description:
        'consiste en la selección de comparables por similitud, cercanía y actualidad temporal, a través de los cuales se genera un análisis estadístico del microentorno generado por dichos comparables. El análisis estadístico generado será el modelo final que definirá el valor del activo.',
    },
    {
      key: 'ML1',
      title: 'Modelo ML o Machine Learning',
      description:
        'se trata de un modelo de inteligencia artificial entrenado con todos aquellos comparables recientes con el objetivo de identificar aquellos patrones que definen el mercado en cada uno de los microentornos inmobiliarios. Este modelo es utilizado para garantizar un 100% de cobertura en la AVM y, por tanto, se utiliza únicamente en aquellos casos en los que el modelo ECO no es capaz de encontrar un mínimo de comparables que cumplan los parámetros establecidos.',
    },
  ],
};

export const termsTexts = {
  main: [
    {
      key: 'description',
      title: 'Descripción del informe',
      description:
        'Este documento hace referencia a Pulse Asset, una herramienta de Accumin Intelligence. Su alcance se corresponde con modelo estadístico propio en el que se describen diferentes indicadores estáticos y dinámicos sobre el comportamiento de la oferta, la demanda y el precio del mercado inmobiliario del área reseñado. Se diferencia dichos indicadores o insights en las diferentes tipologías residenciales. De igual forma los diferentes mapas de calor hacen referencia al comportamiento de dichos indicadores en cada microzona o barrio del municipio.',
    },
    {
      key: 'temporalAndSpatialScope',
      title: 'Alcance temporal y espacial del informe',
      description:
        'Este informe desarrolla los indicadores bajo las tipologías y usos inmobiliarios proporcionados por el cliente. Igualmente refleja las tendencias y dinámicas del mercado inmobiliario en los últimos cuatro trimestres.',
    },
    {
      key: 'obligatoryTerms',
      title: 'Obligatoriedad de las condiciones generales',
      description:
        'Las presentes condiciones generales obligan al cliente por el mero hecho de hacer uso de los documentos sometidos a ellas.',
    },
    {
      key: 'originOfTheBBDD',
      title: 'Origen de las BBDD',
      description:
        'Este informe está desarrollado bajo metodologías propias de Accumin Intelligence, tras el estudio de fuentes externas provenientes de estamentos públicos y privados. Entre otras: INE, Iestadis CAM, catastro, Centro de Procesos Estadísticos (CPE) del Colegio de Registradores, Centro de Proceso de Datos del Consejo General del Notariado, agregadores de portales inmobiliarios, etc..',
    },
    {
      key: 'anonymizedData',
      title: 'Datos anomizados',
      description:
        'La información suministrada por Accumin Intelligence está anonimizada de acuerdo a la legislación vigente en protección de datos personales. Está expresamente prohibido realizar labores de reidentificación de personas a partir de estos datos y otras fuentes de datos e información posibles, pasadas, actuales o futuras de acuerdo a la normativa vigente.',
    },
    {
      key: 'exclusionOfResponsibility',
      title: 'Exclusión de la responsabilidad',
      description: `Este documento es un punto de partida para cualquier persona u organismo interesado en la compra de esta vivienda, local, oficina, edificio o solar a la fecha de consulta. Para estimar estos indicadores y valores, ningún profesional ha realizado ningún documento complementario ni ninguna comprobación adicional relativos a la situación de identificación física, a su inscripción registral, a su legalidad urbanística, calidades, conservación y estabilidad constructivas, u otras posibles limitaciones al valor derivadas de su estado de ocupación o de cesión de uso, al régimen de protección pública al que pudiera estar sujeto, o el régimen de protección del patrimonio arquitectónico, entre otras.
      Por tanto, la pre valoración técnica como la valoración estadística (AVM) carece de validez oficial o legal, y no puede emplearse en el mercado urbanístico, inmobiliario o hipotecario. Para obtener una tasación o documento de viabilidad técnico urbanístico debe visitar un técnico pertinente que realice dichos trabajos.
      La utilización de este conjunto de datos por el cliente se realizará bajo su propia cuenta y riesgo, correspondiéndole en exclusiva a ellos responder frente a terceros por daños que pudieran derivarse de ella.
      Accumin Intelligence no será responsable del uso que de esta información haga el cliente ni tampoco de los daños sufridos o pérdidas económicas que, de forma directa o indirecta, produzcan o puedan producir perjuicios económicos, materiales u otros, provocados por la información reutilizada.`,
    },
    {
      key: 'intellectualProperty',
      title: 'Propiedad intelectual',
      description:
        'Accumin Intelligence posee la propiedad intelectual de la metodología y análisis utilizados en este documento. Esta propiedad queda regulada por la Ley de Protección Intelectual vigente.',
    },
  ],
};

export const AssetFeaturesIconDictionary = {
  has_storage: <Storage title="Storage" />,
  has_pool: <Pool title="Pool" />,
  has_elevator: <Elevator title="Elevator" />,
  is_exterior: <Exterior title="Exterior" />,
  has_garage: <Parking title="Parking" />,
  has_air_conditioner: <AirConditioner title="AirConditioner" />,
  has_terrace: <Terrace title="Terrace" />, 
  has_automatic_door: <AutomaticDoor title="AutomaticDoor" />,
  has_people: <People title="People" />,
  has_security: <Security title="Security" />,
  has_pavement: <Pavement title="Pavement" />,
  has_water: <Water title="Water" />,
  has_sewerage: <Sewerage title="Sewerage" />,
  has_street_lighting: <StreetLighting title="StreetLighting" />,
  has_electricity: <Electricity title="Electricity" />,
  has_natural_gas: <NaturalGas title="NaturalGas" />,
};

export const AssetConditionIconDictionary = {
  1: <Condition />,
};

export const AssetDetailsIconDictionary = {
  area: <Area />,
  floor: <Building />,
  bedrooms: <Bedroom />,
  bathrooms: <Bathroom />,
};
